interface IProps {
    title: string;
}

const Catalog = (props: IProps) => {
    const { title } = props;
    return (
        <div className="Catalog btn">
            <span>{title} </span>
        </div>
    );
};

export default Catalog;
